import { render, staticRenderFns } from "./DynamicTheme.vue?vue&type=template&id=447f6272&"
import script from "./DynamicTheme.vue?vue&type=script&lang=js&"
export * from "./DynamicTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports